let SESSION_PRIVATE_DECODE_KEY;

export async function generatePublicKey() {
  const keyPair = await window.crypto.subtle.generateKey(
    {
      hash: 'SHA-256',
      modulusLength: 2048,
      name: 'RSA-OAEP',
      publicExponent: new Uint8Array([1, 0, 1]),
    },
    true,
    ['encrypt', 'decrypt'],
  );

  const publicKey = await window.crypto.subtle.exportKey('spki', keyPair.publicKey);
  SESSION_PRIVATE_DECODE_KEY = keyPair.privateKey;
  return btoa(String.fromCharCode(...new Uint8Array(publicKey)));
}

export async function decodeToken(token) {
  if (!SESSION_PRIVATE_DECODE_KEY) return;

  const encryptedBytes = Uint8Array.from(atob(token), c => c.charCodeAt(0));
  const decrypted = await window.crypto.subtle.decrypt(
    { name: 'RSA-OAEP' },
    SESSION_PRIVATE_DECODE_KEY,
    encryptedBytes,
  );

  return new TextDecoder().decode(decrypted);
}
